var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"participant-discount-info"},[_c('el-switch',{on:{"change":_vm._onChange},model:{value:(_vm.childrenProgram),callback:function ($$v) {_vm.childrenProgram=$$v},expression:"childrenProgram"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }